import React from "react";
import SideDrawer from "./Components/Drawer/SideDrawer";

function MainBody(props) {
  return <SideDrawer>{props.children}</SideDrawer>;
}

export default MainBody;
